import { UserMenu } from '@/components/layout/user-menu';
import { WorkspaceBadge } from '@/components/layout/workspace-badge';
import { ThemeToggle } from '@/components/theme-toggle';
import { logout } from '@/lib/api/logoutService';
import { useAuth } from '@/providers/AuthProvider';
import { EXTERNAL_LINKS, openExternalLink } from '@/config/external-links';

export function TopNav() {
  const { isAuthenticated, user, isLoading } = useAuth();

  // Generate initials from name or email
  const getInitials = (): string => {
    if (user?.name) {
      const parts = user.name.split(' ');
      if (parts.length > 1 && parts[0] && parts[1]) {
        return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
      }
      if (parts[0]?.[0]) {
        return parts[0][0].toUpperCase();
      }
    }
    if (user?.email?.[0]) {
      return user.email[0].toUpperCase();
    }
    return '?';
  };

  return (
    <header className="border-border bg-header flex h-12 shrink-0 items-center justify-between border-b px-4">
      {/* Left: empty for now (breadcrumbs, page title, etc.) */}
      <div className="flex items-center gap-2" />

      {/* Right: Workspace badge + Theme Toggle + User Menu */}
      <div className="flex items-center gap-3">
        <WorkspaceBadge />
        <ThemeToggle />
        <UserMenu
          isLoading={isLoading}
          isAuthenticated={isAuthenticated}
          user={
            user
              ? {
                  name: user.name || user.email,
                  email: user.email,
                  initials: getInitials(),
                }
              : undefined
          }
          onDocumentationClick={() => {
            openExternalLink(EXTERNAL_LINKS.DOCUMENTATION);
          }}
          onPrivacyClick={() => {
            openExternalLink(EXTERNAL_LINKS.PRIVACY_POLICY);
          }}
          onLogout={() => {
            logout();
          }}
        />
      </div>
    </header>
  );
}
